import { useState, useEffect } from 'react'; 
import { Helmet } from 'react-helmet';
import { Footer } from './styles/Footer.styled.js';
import { NavBar } from './styles/NavBar.styled.js';
import {  ResidentialCleaningAgent } from './styles/SectorSpecialist.styled.js';
import sheffield from './assets/sheffield.jpg';
import { Accordion, AccordionContent } from './styles/Accordion.styled.js';
import { OurColleagues } from './styles/OurColleagues.styled.js';

import { Reviews } from './styles/Reviews.styled.js';
import Caution from './assets/Caution.jpg';
import img3 from './assets/img3.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus } from '@fortawesome/free-solid-svg-icons';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { ShowCaseResidential } from './styles/ShowCase.styled.js';

// or from '@fortawesome/free-regular-svg-icons' depending on the style you want

const CommercialCleaning = () => {
  //Title Page
  useEffect(() => {
    document.title = 'Residential - Residential Cleaning You Can Trust';
  }, []);

  const [offsetRev, setOffsetRev] = useState(0);

  const reviews = [
    {
      img: sheffield,
      title: 'End of Tenancy Cleaning',
      text: '"Did a very Perfect job, Thank you."',
      name: 'Jamie',
      location: 'Sheffield',
    },
    {
      img: sheffield,
      title: 'One Time Cleaning',
      text: '"Cleaner was very fast and does the job well."',
      name: 'Nada',
      location: 'Sheffield',
    },
    {
      img: sheffield,
      title: 'Deep Cleaning',
      text: '"Thank you for the amazing job raf.. My house is now sparkling."',
      name: 'Carshena',
      location: 'Sheffield',
    },
    {
      img: sheffield,
      title: 'Move In Cleaning',
      text: '"My house now looks perfect, will keep on using you weekly. Thanks Raf."',
      name: 'Myles W',
      location: 'Chesterfield',
    },
    {
      img: sheffield,
      title: 'Carpet Cleaning',
      text: '"Amazing job guys!"',
      name: 'Linda',
      location: 'Nottingham',
    },
    {
      img: sheffield,
      title: 'After Renovation Cleaning',
      text: '"My Dad said you did a good jobThank you guys "',
      name: 'Nevila',
      location: 'Sheffield',
    },
    {
      img: sheffield,
      title: 'Oven Cleaning',
      text: '"I would rate you very good. I had a quick responce from you.I was very pleased with the work done & would recommend. Thank you "',
      name: 'June S.',
      location: 'Stockport',
    },
  ];

  const handleNextRev = () => {
    if (offsetRev < reviews.length - 2) {
      // show 3 at a time
      setOffsetRev(offsetRev + 1);
    }
  };

  const handlePrevRev = () => {
    if (offsetRev > 0) {
      setOffsetRev(offsetRev - 1);
    }
  };



  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const items = [
    {
      question: 'What does your residential cleaning service include?',
      answer:
        'Our service covers general cleaning of living areas, kitchens, and bathrooms, plus optional deep cleaning of appliances, upholstery, and hard‑to‑reach spaces.',
    },
    {
      question: ' Do I need to provide cleaning supplies? ',
      answer:
        'No. We bring our own professional, eco‑friendly products and equipment. If you prefer specific products, we’re happy to use them.',
    },
    {
      question: 'How often should I schedule cleaning?  ',
      answer:
        'It depends on your lifestyle. Many clients choose weekly or bi‑weekly visits, while others book monthly deep cleans.',
    },
    {
      question: 'Can I customize the cleaning plan?  ',
      answer:
        'Yes. We tailor every plan to your home’s needs, whether you want a focus on kitchens, bathrooms, or full‑house care.',
    },
    {
      question: 'Are your cleaners trained and insured?',
      answer:
        'Absolutely. Our team is fully trained, background‑checked, and insured for your peace of mind.',
    },
    {
      question: 'How long does a typical cleaning take?',
      answer:
        'The duration depends on the size of your home and the scope of work. A standard 3‑bedroom home usually takes 2–3 hours.',
    },
    {
      question: 'Do you offer one‑time or move‑in/move‑out cleaning?  ',
      answer:
        'Yes. We provide flexible one‑time services, including move‑in/move‑out and post‑renovation cleaning.',
    },
    {
      question: 'What if I’m not satisfied with the cleaning?  ',
      answer:
        'We guarantee quality. If something isn’t right, we’ll return promptly to make it right at no extra cost.',
    },
    {
      question: 'Is eco‑friendly cleaning available?  ',
      answer:
        'Yes. We use safe, non‑toxic products that protect your family, pets, and the environment.',
    },
    {
      question: 'How do I book a cleaning appointment?  ',
      answer:
        'You can schedule easily through our website or by contacting our customer service team. We’ll arrange a time that works best for you.',
    },
  ];

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
        />
      </Helmet>
      <NavBar></NavBar>
      <ShowCaseResidential>
        <div className="center">
          <div className="titleBox">
            <h1>Residential Cleaning Services</h1>
            <p>
              We bring professional-grade standards to your private residence. By utilizing precision cleaning strategies tailored to your home's unique needs, we ensure a safe, spotless, and perfectly maintained environment.
            </p>
          </div>
        </div>
      </ShowCaseResidential>
      <ResidentialCleaningAgent>
        <div className="container">
          <div className="row">
            <div className="col_2">
              <h1>Residential Cleaning You Can Trust </h1>
              <p>
                Rade Integrated Services Ltd elevates the standards of residential cleaning. We go beyond the surface to provide thorough, eco-conscious cleaning that restores and maintains your home's beauty. Whether you require a one-off deep clean or regular upkeep, we deliver the peace of mind that comes with a truly immaculate space.
              </p>
            </div>
            <div className="col_1">
              <a
                href="https://www.freepik.com/free-photo/full-shot-blurry-man-vacuuming-floor_24492551.htm#fromView=serie&page=1&position=24"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Caution} alt="responsibility" />
              </a>
            </div>
          </div>
        </div>
      </ResidentialCleaningAgent>
      <OurColleagues>
        <div className="container">
          <div className="row">
            <div className="col_1">
              <img src={img3} alt="Operation" />
            </div>
            <div className="col_2">
              <h1>Empowering Your Operations Through Our People</h1>
              <p>
                Our cleaning professionals work as an extension of your own team, aligning our services with your organization's core mission. We focus on delivering measurable results and operational resilience through industry best practices. By fostering a culture of unity and mutual support, we ensure our teams are consistent, reliable, and always ready to meet your needs.
              </p>
            </div>
          </div>
        </div>
      </OurColleagues>
      <Reviews offsetRev={offsetRev}>
        <div className="container">
          <div className="heading">
            <h3>Client Feedback</h3>
            <h1>Comments From Clients</h1>
          </div>
          <div className="carousel-container">
            <div className="carousel">
              {reviews.map((review, i) => (
                <div className="card" key={i}>
                  <img src={review.img} alt={review.title} />
                  <div className="content">
                    <div className="content_header">
                      <h3>{review.title}</h3>
                      <FontAwesomeIcon
                        icon={faCircleCheck}
                        className="plusIcon"
                      />
                    </div>
                    <p>{review.text}</p>
                    <p>
                      - {review.name}, <br/>{review.location}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <button
              className="carousel-button left-button"
              onClick={handlePrevRev}
            >
              &#10094;
            </button>
            <button
              className="carousel-button right-button"
              onClick={handleNextRev}
            >
              &#10095;
            </button>
          </div>
        </div>
      </Reviews>
      <Accordion>
        <div className="container">
          <div className="row">
            <h1>Frequently asked questions for Cleaning</h1>
            <div className="accordion">
              {items.map((item, index) => (
                <div className="accordion-items" key={index}>
                  <button
                    className="accordionButton"
                    onClick={() => toggleAccordion(index)}
                  >
                    <h3>{item.question}</h3>
                    <div className="iconWrapper">
                      {openIndex !== index && (
                        <FontAwesomeIcon icon={faPlus} className="btn" />
                      )}
                      {openIndex === index && (
                        <FontAwesomeIcon icon={faMinus} className="btn" />
                      )}
                    </div>
                  </button>
                  <AccordionContent isOpen={openIndex === index}>
                    <p>{item.answer}</p>
                  </AccordionContent>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Accordion>
      {/* Footer */}
      <Footer></Footer>
    </>
  );
};

export default CommercialCleaning;
